import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=4c27d25a&"
import script from "./goals.vue?vue&type=script&lang=ts&"
export * from "./goals.vue?vue&type=script&lang=ts&"
import style0 from "./goals.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports